// Libraries
import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

const StyleImageIcon = styled.img`
  height: 24px;
  width: 24px;
  border-radius: 50%;
`;

const ImageIcon = (props) => {
    // Props
    if (props.src) {
      return (
        <StyleImageIcon {...props} />
      );  
    }
    return null
};

export default ImageIcon;